﻿import { proxyTexts } from "@serenity-is/corelib/q";

namespace Serenity.Pro.Extensions.Texts {

    export declare namespace Controls {

        namespace IdleTimeout {
            export const CountdownMessage: string;
            export const KeepAliveButton: string;
            export const SignoutButton: string;
            export const WarningMessage: string;
            export const WarningTitle: string;
        }
    }

    export declare namespace Forms {

        namespace Membership {

            namespace Elevation {
                export const ActionRequiresElevation: string;
                export const ConfirmAccess: string;
                export const ElevateButton: string;
                export const FormTitle: string;
                export const InvalidPassword: string;
            }
        }
    }

    export declare namespace Site {

        namespace CardViewMixin {
            export const CardView: string;
            export const ListView: string;
        }

        namespace DraggableGroupingMixin {
            export const CollapseAllButton: string;
            export const DropPlaceholder: string;
            export const ExpandAllButton: string;
        }

        namespace FavoriteViewsMixin {
            export const DeleteButtonHint: string;
            export const DeleteSuccessMessage: string;
            export const EmptyNameError: string;
            export const FavoriteViews: string;
            export const LoadedViewMessage: string;
            export const SaveButton: string;
            export const SaveSuccessMessage: string;
            export const SaveView: string;
        }

        namespace HeaderFiltersMixin {
            export const CancelButton: string;
            export const ClearButton: string;
            export const OkButton: string;
            export const Search: string;
            export const SelectAll: string;
        }

        namespace WizardDialog {
            export const BackButton: string;
            export const CancelButton: string;
            export const CancelMessage: string;
            export const FinishButton: string;
            export const NextButton: string;
        }

    }

    Serenity.Pro.Extensions['Texts'] = proxyTexts(Texts, '', {
        Controls: {
            IdleTimeout: {}
        },
        Forms: {
            Membership: {
                Elevation: {}
            }
        },
        Site: {
            CardViewMixin: {},
            DraggableGroupingMixin: {},
            FavoriteViewsMixin: {},
            HeaderFiltersMixin: {},
            WizardDialog: {}
        }
    }) as any;
}

export const Texts = Serenity.Pro.Extensions.Texts;